import { MouseEventHandler, ReactNode } from 'react';
import { Color } from '../../lib/types.ts';
import { cn } from '../../lib/helpers.ts';

interface TabProps {
    children: ReactNode;
    color: Color | 'product';
    onClick?: MouseEventHandler; // TODO: change
    active?: boolean;
    ref?: never; // TODO: change
}

export default function Tab({
    children,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // color,
    onClick,
    ref,
    active = false,
}: TabProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // const colorVariants = {
    //     blue: 'bg-blue-500',
    //     green: 'bg-green-500',
    //     orange: 'bg-orange-500',
    //     red: 'bg-red-500',
    //     turquoise: 'bg-turquoise-500',
    //     purple: 'bg-purple-500',
    //     rose: 'bg-rose-500',
    //     product: 'bg-product-500',
    // };

    return (
        <button
            role="tab"
            ref={ref}
            className={cn(
                'relative rounded-xl px-4 py-2 font-medium',
                // 'transition-colors',
                active && 'text-white', // shadow-sm
                // active ? colorVariants[color] : 'hover:bg-cloud-200'
                !active && 'transition-colors hover:bg-cloud-200'
            )}
            onClick={onClick}
        >
            {children}
        </button>
    );
}
